import React, { Fragment } from "react";
import cx from "classnames";
import FBIcon from "./fb.svg"
import IGIcon from "./ig.svg"
import TTIcon from "./tt.svg"
import TAIcon from "./ta.svg"
import styles from "./styles.module.sass";

interface SocialIconsProps {
  containerClassName?: string;
  className?: string;
  showTA?: boolean;
}

const SocialIcons: React.FC<SocialIconsProps> = ({
  containerClassName = "",
  className = "",
  showTA = false,
}) => (
  <div className={containerClassName}>
    <div className={cx(className, styles.social)}>
      {!showTA && (
        <Fragment>
          <a
            rel="noopener noreferrer"
            href="https://www.facebook.com/lloydsinn"
            target="_blank"
          >
            <FBIcon className={styles.socialIcon} />
          </a>
          <a
            rel="noopener noreferrer"
            href="https://www.instagram.com/lloydsinn/"
            target="_blank"
          >
            <IGIcon className={styles.socialIcon} />
          </a>
          <a
            rel="noopener noreferrer"
            href="https://www.tiktok.com/@lloydsinn"
            target="_blank"
          >
            <TTIcon className={styles.socialIcon} />
          </a>
        </Fragment>
      )}
      {showTA && (
        <a
          rel="noopener noreferrer"
          href="https://www.tripadvisor.com.au/Hotel_Review-g294265-d338321-Reviews-Lloyd_s_Inn-Singapore.html"
          target="_blank"
        >
            <TAIcon className={styles.socialIcon} />
        </a>
      )}
    </div>
  </div>
);

export default SocialIcons;
